import type { ReactNode } from 'react';
import { ScOfferTitles } from '../OfferCard/styled';
import {
  ScOfferAmount,
  ScOfferDivider,
  ScOfferInfo,
  ScOfferYouWon,
} from './styled';

interface IWinInfoProps {
  amount: string;
  title: string;
  className?: string;
  children?: ReactNode;
}

export const WinInfo = ({
  amount,
  title,
  className,
  children,
}: IWinInfoProps) => (
  <ScOfferInfo>
    <ScOfferTitles>
      <ScOfferYouWon className={className}>{title}</ScOfferYouWon>
      <ScOfferAmount data-text={amount}>{amount}</ScOfferAmount>
    </ScOfferTitles>
    <ScOfferDivider />
    {children}
  </ScOfferInfo>
);
